<template>
  <CListGroup class="list-group-accent">
    <CListGroupItem
      class="list-group-item-accent-secondary bg-light text-center
      font-weight-bold text-muted text-uppercase small"
    >
      <BInputGroup size="sm" prepend="경보">
        <BFormSelect size="sm"
                     class="mr-2 theme-select"
                     v-model="fromDays"
                     @input="selectDayOpts"
                     :options="dayFromOpts"
        />
        <BInputGroupAppend>
          <BButton size="sm" variant="danger" style="min-width:80px" pill>
            <strong>{{ comma($store.state.alarm.count.total) }}</strong>
          </BButton>
        </BInputGroupAppend>
      </BInputGroup>
    </CListGroupItem>

    <CListGroupItem v-for="(evtName,key) in visibleEventCodeMap" :key="key"
                    :href="`/#/monitor/events?code=${key}&from=${fromDays}`"
                    class="small p-1 m-0"
                    :class="`list-group-item-accent-${eventColor[key]}`"
    >
      <div class="float-left">
        <BBadge class="font-lg btn" style="min-width:120px" :variant="eventColor[key]" @click="selectEventCode(key)">
          <strong>{{ evtName }}</strong>
        </BBadge>
      </div>
      <BSpinner variant="danger" class="ml-1 mt-2" small v-show="received[key]" type="grow" label="Spinning"/>
      <div class="float-right">
        <BButton size="sm"
                 class="ml-1"
                 :variant="`outline-${eventColor[key]}`"
                 style="min-width:90px" pill>
          <strong>{{ comma($store.state.alarm.count[key]) }}</strong>
        </BButton>
      </div>
    </CListGroupItem>
  </CListGroup>
</template>

<script>
import '@/common/HelperMixin';
import moment from "moment";
import qs from 'querystring';
import { apiCall, comma, speech, sleep } from '@/common/utils';
import { EVENT_COLOR } from '@/common/constants';

// 경보판(경보현황·경보지연 설정)에서 감추는 경보 코드: 8 센서점검
// 서버 코드맵(EVENT)은 8 센서점검, 9 설정점검 이며, 서버(core/PolCore.js)는 점검류 경보를
// 모두 9 로만 내보낸다. 8 은 코드맵에만 있고 실제로 발생하지 않는다.
const HIDDEN_EVENT_CODE = '8';

export default {
  name: 'AlarmConfigList',
  props: {
    // 소켓으로 방금 수신한 경보코드 표시용 { code: true }. 소켓은 TheAside 만 수신한다.
    received: { type: Object, default: () => ({}) },
    // 최초 조회 결과를 음성으로 안내할지 여부 (Aside 에서만 true)
    announce: { type: Boolean, default: false },
  },
  computed: {
    // 경보현황에 보여줄 경보. 센서점검(8)은 경보판에서 다루지 않아 뺀다
    visibleEventCodeMap(){
      const map = { ...(this.eventCodeMap || {}) };
      delete map[HIDDEN_EVENT_CODE];
      return map;
    },
  },
  data () {
    return {
      comma,
      eventColor: EVENT_COLOR,
      eventCodeMap: null,
      fromDays: 3,
      toDts: null,
      dayFromOpts: [
        {value:3, text:'최근 3일'},
        {value:7, text:'최근 7일'},
        {value:14, text:'최근 2주'},
        {value:28, text:'최근 4주'},
        {value:90, text:'최근 3개월'},
      ],
    }
  },
  async mounted() {
    try{
      // 로그인 직후에는 코드/탱크 기본정보 적재가 끝나지 않았을 수 있다.
      for(let i=0; i<20 && !this.$store.state.codeMaps['EVENT']; i++) await sleep(500);

      this.eventCodeMap = this.$store.state.codeMaps['EVENT'];
      this.fromDays = this.$store.state.alarm.count.fromDays || 3;
      this.toDts = moment().toISOString();

      await this.getCount(this.announce);

    }catch(err){
      console.error(err);
    }
  },
  methods: {
    async selectDayOpts(){
      this.toDts = moment().format('YYYY-MM-DD');
      await this.getCount(true);
      this.$emit('change-days', this.fromDays);
    },

    /** 경보 뱃지 클릭: 선택 코드를 상위 화면에 전달 */
    selectEventCode(code){
      this.$emit('select-code', code);
    },

    async getCount(withSpeech=false) {
      const paramMap = {};
      try{
        this.$store.state.alarm.count.fromDays = this.fromDays;
        paramMap['fromDts'] = moment().subtract(this.fromDays, 'days').toISOString();
        if(this.toDts) paramMap['toDts'] = this.toDts;

        const {result} = await apiCall('get', `/api/event/count?${qs.stringify(paramMap)}`);
        if(!result) return;

        let totalCount = 0;
        const alarmCount = this.$store.state.alarm.count;
        Object.keys(alarmCount).map(k=>{ alarmCount[k] = 0; });

        result.map(r=>{
          alarmCount[r.code] = r.count;
          totalCount += r.count;
        })
        alarmCount.total = totalCount;
        alarmCount.fromDays = this.fromDays;

        if(withSpeech) speech(`최근 ${this.fromDays}일 동안, ${totalCount} 건의 경보 발생.`);

      }catch(err){
        console.error(err);
      }
    },
  }
}
</script>
